import { render, staticRenderFns } from "./templatesDataExportWidget.vue?vue&type=template&id=46598d80&scoped=true"
import script from "./templatesDataExportWidget.vue?vue&type=script&lang=js"
export * from "./templatesDataExportWidget.vue?vue&type=script&lang=js"
import style0 from "./templatesDataExportWidget.vue?vue&type=style&index=0&id=46598d80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46598d80",
  null
  
)

export default component.exports